var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FECFCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2473 32C20.8923 32 19.5713 31.985 18.2643 31.958C16.5923 31.925 15.4353 30.841 15.2463 29.129C14.9313 26.289 14.3923 19.595 14.3873 19.528C14.3533 19.115 14.6613 18.753 15.0743 18.72C15.4813 18.709 15.8493 18.995 15.8823 19.407C15.8873 19.475 16.4253 26.146 16.7373 28.964C16.8443 29.937 17.3693 30.439 18.2953 30.458C20.7953 30.511 23.3463 30.514 26.0963 30.464C27.0803 30.445 27.6123 29.953 27.7223 28.957C28.0323 26.163 28.5723 19.475 28.5783 19.407C28.6113 18.995 28.9763 18.707 29.3853 18.72C29.7983 18.754 30.1063 19.115 30.0733 19.528C30.0673 19.596 29.5253 26.307 29.2133 29.122C29.0193 30.869 27.8653 31.932 26.1233 31.964C24.7903 31.987 23.5043 32 22.2473 32",
    fill: "#ED3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.708 16.9893H13.75C13.336 16.9893 13 16.6533 13 16.2393C13 15.8253 13.336 15.4893 13.75 15.4893H30.708C31.122 15.4893 31.458 15.8253 31.458 16.2393C31.458 16.6533 31.122 16.9893 30.708 16.9893",
    fill: "#ED3B3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4406 16.9893C26.3026 16.9893 25.3146 16.1783 25.0906 15.0623L24.8476 13.8463C24.7966 13.6613 24.5856 13.5003 24.3456 13.5003H20.1126C19.8726 13.5003 19.6616 13.6613 19.6006 13.8923L19.3676 15.0623C19.1446 16.1783 18.1556 16.9893 17.0176 16.9893C16.6036 16.9893 16.2676 16.6533 16.2676 16.2393C16.2676 15.8253 16.6036 15.4893 17.0176 15.4893C17.4436 15.4893 17.8136 15.1853 17.8976 14.7673L18.1406 13.5513C18.3876 12.6193 19.1946 12.0003 20.1126 12.0003H24.3456C25.2636 12.0003 26.0706 12.6193 26.3076 13.5063L26.5616 14.7673C26.6446 15.1853 27.0146 15.4893 27.4406 15.4893C27.8546 15.4893 28.1906 15.8253 28.1906 16.2393C28.1906 16.6533 27.8546 16.9893 27.4406 16.9893",
    fill: "#ED3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.d81142d0dabd5d0e02de44113ae4afb4.svg";
export { ForwardRef as ReactComponent };